import { ScheduledReportSummaryFilters } from 'src/features/scheduledReportSummary/useFilters'
import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.scheduledReportSummary

/**
 * API リクエストに関わる絞り込み条件のみを抜き出した型。
 *
 * `scheduleNameKeyword` はクライアントサイド絞り込み用であり、API リクエストや
 * queryKey に含めるとキャッシュキーが意図せず分散するため、型レベルで除外する。
 */
export type ScheduledReportSummariesApiFilters = Pick<
  ScheduledReportSummaryFilters,
  'dateRange' | 'placeNodeUuids'
>

export const queryKeys = {
  scheduledReportSummariesWithDaysInfo: (
    filters: ScheduledReportSummariesApiFilters,
  ) => [
    ...prefix,
    'scheduledReportSummariesWithDaysInfo',
    // Pick は型レベルの絞り込みでしかなく、structural subtyping により
    // 余計なプロパティを持つオブジェクトもこの関数に渡せてしまう。
    // ランタイムでも queryKey に余計なプロパティが混入しないよう、
    // ここで必要なプロパティのみを明示的に取り出して新しいオブジェクトを組み立てる。
    {
      dateRange: filters.dateRange,
      placeNodeUuids: filters.placeNodeUuids,
    },
  ],
}
